import React from "react";
import { string, oneOfType, number, objectOf, object, shape, array, oneOf } from "prop-types";
import cx from "classnames";
import { LOCAL_EN, LOCAL_FR } from "../../../const/const";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../sharedComponents/Card";
import { StarRating } from "../../StarRating";
import { FormattedMoney } from "../../FormattedMoney";
// eslint-disable-next-line import/no-cycle
import { CardLink } from "../HeroCard";
import * as styles from "./HotelCard.module.scss";

const HotelCard = ({
	image,
	header,
	link,
	className,
	style,
	subheader,
	stars,
	days,
	save,
	wasPrice,
	price,
	local,
	labels,
}) => (
	<Card className={cx(styles.hotel, className)} style={style}>
		<Card.Header className={cx(styles.heading)}>{header}</Card.Header>
		<Card.Image
			src={!image.srcSet && image.src}
			source={image.srcSet && image}
			alt={image.alt}
			fluid={image.fluid}
		/>
		<Card.BodyContainer className={cx(styles.contentContainer)}>
			{subheader && <Card.Subheader className={cx(styles.subheading)}>{subheader}</Card.Subheader>}
			{stars && <StarRating rating={stars} className={cx(styles.star)} />}
			<div className={cx(styles.days)}>
				<span>{labels.departureDate}</span>
				<span>{days}</span>
				<span>{labels.allInc && labels.allInc}</span>
			</div>
			{price && (
				<div className={cx(styles.price)}>
					<div className={cx(styles.save)}>{save}</div>
					{wasPrice && (
						<div className={cx(styles.was)}>
							{labels.was}{" "}
							<span>
								<FormattedMoney number={wasPrice} local={local} />
							</span>
						</div>
					)}
					<div className={cx(styles.amount)}>
						<FormattedMoney number={price} local={local} />
						{labels?.perAdult && <span>{labels.perAdult}</span>}
					</div>
					{labels?.taxAndFee && labels.taxAndFee}
				</div>
			)}
		</Card.BodyContainer>
		{link?.to && (
			<CardLink link={link.to} text={subheader && subheader} className={cx(styles.hotelLink)} />
		)}
	</Card>
);

HotelCard.propTypes = {
	image: shape({
		fluid: oneOfType([object, array]),
		fixed: oneOfType([object, array]),
		source: shape({
			src: string,
			srcSet: string,
			sizes: string,
		}),
		alt: string,
		src: string,
	}).isRequired,
	header: string.isRequired,
	subheader: string,
	link: shape({
		to: string.isRequired,
		target: string,
		icon: string,
		text: string,
	}).isRequired,
	className: string,
	style: objectOf(oneOfType([string, number])),

	stars: number.isRequired,
	days: string.isRequired,
	save: string.isRequired,
	wasPrice: number.isRequired,
	price: number.isRequired,
	local: oneOf([LOCAL_FR, LOCAL_EN]),
	labels: shape({
		allInc: string,
		was: string,
		perAdult: string,
		taxAndFee: string,
	}),
};

HotelCard.defaultProps = {
	className: "",
	style: {},
	subheader: null,
	local: LOCAL_EN,
	labels: {},
};

export default HotelCard;
export { HotelCard };
